export default __webpack_public_path__ + "static/media/330_business05-en-web.7dc0c3c7.png";